import React, { useContext } from 'react';
import styled from 'styled-components';

import { LocaleContext } from '@rsc/contexts/LocaleContext';

import breakpoints from '@rsc/ui-components/breakpoints';
import sharedStyles from '@rsc/ui-components/styles';
import LinkComponent from '@rsc/ui-components/LinkComponent';

import ClipboardIcon from '@rsc/ui-components/svgs/bs-clipboard-check.svg';
import BatteryIcon from '@rsc/ui-components/svgs/bs-battery-full.svg';
import { LocaleCurrencyEnum } from '@rsc/models/LocaleCurrencyEnum';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${sharedStyles.spacing['spacing-lg']};

  a {
    display: flex;
    width: 100%;
    padding: ${sharedStyles.spacing['spacing-md']};
    border: 1px solid ${({ theme }) => theme.colors.brandPrimary};
    color: ${({ theme }) => theme.colors.brandPrimary};
    gap: ${sharedStyles.spacing['spacing-md']};

    @media (min-width: ${breakpoints.md}) {
      width: calc(50% - ${sharedStyles.spacing['spacing-md']});
    }
  }

  span {
    display: inline-block;
    text-decoration: none;
  }

  svg {
    align-self: center;
  }
`;

const LinkContent = styled.div`
  p {
    font-weight: ${sharedStyles.fontWeight.extraBold};
    margin: 0;
  }
`;

function LinkButtons() {
  const { currency } = useContext(LocaleContext);
  return (
    <Container>
      <LinkComponent
        to={
          currency === LocaleCurrencyEnum.CAD
            ? '/en-ca/free-consultation'
            : '/free-consultation'
        }
      >
        <ClipboardIcon />
        <LinkContent>
          <p>Not Yet a Customer?</p>
          <span>Schedule a Consultation</span>
        </LinkContent>
      </LinkComponent>
      <LinkComponent
        to={
          currency === LocaleCurrencyEnum.CAD
            ? '/en-ca/shop/batteries'
            : '/shop/batteries'
        }
      >
        <BatteryIcon />
        <LinkContent>
          <p>Existing Customer?</p>
          <span>Shop Batteries</span>
        </LinkContent>
      </LinkComponent>
    </Container>
  );
}

export default LinkButtons;
